export type AuthorToolKey =
    | "ai_assistant"
    | "dictation"
    | "chapter_import"
    | "story_import"
    | "cover_generation"
    | "chapter_image_upload"
    | "wiki_generation";

export interface AuthorToolContext {
    toolKey: AuthorToolKey;
    invocationId: string;
    surface: string;
    storyId?: string;
    chapterId?: string;
    wikiId?: string;
    chapterStatus?: "draft" | "published";
}

export function authorToolProperties(
    args: AuthorToolContext,
): Record<string, unknown> {
    return {
        tool_key: args.toolKey,
        invocation_id: args.invocationId,
        surface: args.surface,
        story_id: args.storyId ?? null,
        chapter_id: args.chapterId ?? null,
        wiki_id: args.wikiId ?? null,
        chapter_status: args.chapterStatus ?? null,
    };
}
